export default "__VITE_ASSET__C3ujmb67__"